import { Col, Row } from "reactstrap";
import PlaylistData from "../playlist/data/PlaylistData";
import PlaylistSummaryItemList from "./PlaylistSummaryItemList";
import { CyPlaylistIndex } from "./CyPlaylistIndex";
import { LookupSongFunction } from "../common/LookupSongFunction";
import { formatDateTime } from "../helper/formatDateTime";
import { useTranslation } from "react-i18next";

interface Props {
  playlistData: PlaylistData;
  showDetailsInPlaylistSummary: boolean;
  lookupSong: LookupSongFunction;
}

export function PlaylistSummary({
  playlistData,
  showDetailsInPlaylistSummary,
  lookupSong,
}: Props) {
  const { t } = useTranslation();

  return (
    <>
      <Row>
        <Col xs={12} lg={8}>
          <span className="lead" data-cy={CyPlaylistIndex.PlaylistTitle}>
            {playlistData.title}
          </span>
        </Col>
        <Col lg={2}>
          <span className="d-lg-none">{t("playlist.summary.created")} </span>
          {formatDateTime(playlistData.createdAt)}
        </Col>
        <Col lg={2}>
          <span className="d-lg-none">{t("playlist.summary.updated")} </span>
          {formatDateTime(playlistData.updatedAt)}
        </Col>
      </Row>
      <Row>
        {showDetailsInPlaylistSummary && (
          <PlaylistSummaryItemList
            playlistData={playlistData.getItems()}
            lookupSong={lookupSong}
          />
        )}
      </Row>
    </>
  );
}
